module.exports = __webpack_public_path__ + "img/3d-model_en.41bfe61.jpg";